import { cn } from "@/zapi-frontend/shared/lib/utils";

type TTypingDotsProps = {
  className?: string;
};

export function TypingDots({ className }: TTypingDotsProps) {
  return (
    <div className={cn("flex h-[22px] items-center gap-[4px]", className)} aria-label="Typing" role="status">
      <span
        className="size-[6px] animate-pulse rounded-full bg-innoveraZinc-300"
        style={{ animationDelay: "0ms", animationDuration: "1200ms" }}
      />
      <span
        className="size-[6px] animate-pulse rounded-full bg-innoveraZinc-400"
        style={{ animationDelay: "200ms", animationDuration: "1200ms" }}
      />
      <span
        className="size-[6px] animate-pulse rounded-full bg-innoveraZinc-300"
        style={{ animationDelay: "400ms", animationDuration: "1200ms" }}
      />
    </div>
  );
}
